import { SearchTermType } from '@libs/trip-planner-interfaces';
import type { IngredientType, SearchTerm } from '@libs/trip-planner-interfaces';
import type { PolygonConstraint } from '@libs/constraint-builder';
import {
  HotelCodeConstraint,
  PolygonIdConstraint,
  serializeConstraint,
} from '@libs/constraint-builder';

import { BaseIngredient } from './baseIngredient';

export abstract class DestiationIngredient<
  T extends IngredientType.Hotel | IngredientType.OwnStay,
> extends BaseIngredient<T> {
  public displayText = '';
  public polygonConstraint?: PolygonConstraint;
  public numberOfNights?: number;

  constructor(
    ingredientType: T,
    public searchTerm: SearchTerm
  ) {
    super(ingredientType);
    this.setSearchTerm(searchTerm);
  }

  public setSearchTerm(newSearchTerm: SearchTerm): void {
    this.searchTerm = newSearchTerm;

    this.displayText =
      newSearchTerm.type === SearchTermType.FreeText
        ? newSearchTerm.freeText
        : '';
  }

  public getSearchText(): string {
    if (this.searchTerm.type === SearchTermType.HotelCode) {
      return serializeConstraint({
        selection: new HotelCodeConstraint(this.searchTerm.hotelCode),
      });
    }

    if (this.searchTerm.type === SearchTermType.PolygonId) {
      return serializeConstraint({
        selection: new PolygonIdConstraint(this.searchTerm.polygonId),
      });
    }

    return this.searchTerm.freeText;
  }
}
